
import {
  defineComponent
} from 'vue';

import {
  GithubRepository, GithubPullRequest
} from '../types/GithubData'

export default defineComponent({
  name: 'Repo',
  props: {
    repo: {
      type: Object as () => GithubRepository,
      required: true
    },
    pulls: {
      type: Object as () => GithubPullRequest[],
      required: true
    }
  }
});
